import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, OnInit, PLATFORM_ID } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { AuthModel } from '../../models/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
    private jwtHelper: JwtHelperService;
    private authModel: AuthModel;

    constructor(
        private readonly cookieService: CookieService,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.jwtHelper = new JwtHelperService();
        this.authModel = new AuthModel();

        this.setInit();
    }

    public setInit(paramToken?: string): void {
        const token = paramToken ?? this.token;
        if (token == null) return;

        const decode = this.jwtHelper.decodeToken(token);
        if (!!decode) {
            const { type, label_rol, email, name, last_name, created_at, id } = decode.user;
            this.authModel.email = email;
            this.authModel.fullName = `${name} ${last_name}`;
            this.authModel.idUser = id;
            this.authModel.isAuthenticated = !this.jwtHelper.isTokenExpired(token);
            this.authModel.labelRol = label_rol;
            this.authModel.registerDate = created_at;
            this.authModel.rolCode = type;
        }
    }

    public isAuthenticated(): boolean {
        const token = this.token;
        if (!!!token || this.token == null) {
            return false;
        }

        return !this.jwtHelper.isTokenExpired(token);
    }

    public checkRols(roles: string[]): boolean {
        if (!!!roles) {
            return true;
        }

        if (isPlatformBrowser(this.platformId)) {
            return roles.some(r => r === this.rolCode);
        }
        
        return false;
    }

    public get rolCode(): string {
        return this.authModel.rolCode;
    }

    public get labelRol(): string {
        return this.authModel.labelRol;
    }

    public get email(): string {
        return this.authModel.email;
    }

    public get fullName(): string {
        return this.authModel.fullName;
    }

    public get registerDate(): Date {
        return this.authModel.registerDate;
    }

    public get idUser(): number {
        return this.authModel.idUser;
    }

    private get token(): string | null {
        if (!isPlatformBrowser(this.platformId)) {
            const token = this.cookieService.get('token');
            
            if (token != null && token.length > 10) {
                return token;
            }
        } else {
            const token = localStorage.getItem('token');
            if (token != null && token.length > 10) {
                return token;
            }
        }

        return null;
    }
}
